export default __webpack_public_path__ + "static/media/headerBgSmall.9234e25f.jpg";